import { Row } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import useTheme from '@guestyci/foundation/useTheme';
import { ReactComponent as IcoNotice } from '@guestyci/icons/IcoNotice.svg';

interface IErrorMessageProps {
  message?: string;
  icon?: boolean;
}

function ErrorMessage({ message, icon }: IErrorMessageProps) {
  const theme = useTheme();

  if (!message) {
    return null;
  }

  return (
    <Row spacing={2}>
      {icon && <IcoNotice fill={theme.palette.error.default} width={20} />}

      <TextField color="error">{message}</TextField>
    </Row>
  );
}

export default ErrorMessage;
